<template>
  <div class="register-form mt-40 d-lg-flex">
    <register-steps></register-steps>
    <div class="row flex-fill">
      <div :class="configSelected ? 'col-xl-9' : 'col-xl-12'">
        <div class="register-slides flex-fill h-100">
          <transition name="scale-fade" mode="out-in">
            <company-information v-if="step === 1"></company-information>
            <service-configuration v-if="step === 2"></service-configuration>
            <financial-data  v-if="step === 3"></financial-data>
            <setup-done v-if="step === 4"></setup-done>
          </transition>
        </div>
      </div>
      <div class="col-xl-3" :class="{'d-none': !configSelected}">
        <div class="mb-20 d-xl-none"></div>
        <register-summary></register-summary>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import RegisterSteps from '@/components/register/RegisterSteps.vue'
import ServiceConfiguration from '@/components/register/ServiceConfiguration.vue'
import CompanyInformation from '@/components/register/CompanyInformation.vue'
import FinancialData from '@/components/register/FinancialData.vue'
import SetupDone from '@/components/register/SetupDone.vue'
import RegisterSummary from '@/components/register/RegisterSummary.vue'

export default {
  name: 'register-form',
  components: {
    RegisterSteps,
    ServiceConfiguration,
    CompanyInformation,
    FinancialData,
    SetupDone,
    RegisterSummary
  },
  computed: {
    ...mapFields({
      step: 'registration.step',
      paymentAcceptance: 'paymentAcceptance',
      services: 'services'
    }),
    configSelected() {
      const merged = [].concat(this.paymentAcceptance, this.services)
      return merged.filter(el => el.selected).length
    }
  },
}
</script>
